export const sasAlgoliaApi = {
  checkoutTerms: 'configuration/v1/algolia/subscription-list/terms-and-conditions/checkout',
  discounts: 'configuration/v1/algolia/subscription-list/discounts',
  facets: 'configuration/v1/algolia/facets',
  faq: 'configuration/v1/algolia/subscription-list/faq',
  hourRange: 'configuration/v1/algolia/subscription-list/schedule',
  image: 'configuration/v1/algolia/subscription-list/media/image',
  periodicity: 'configuration/v1/algolia/subscription-list/periodicity',
  productDetail: 'configuration/v1/algolia/subscription-list/card/product/detail', 
  restrictedDates: 'configuration/v1/algolia/subscription-list/restriction/dates',
  schedule: 'configuration/v1/algolia/subscription-list/schedule',
  subscriptionProperties: 'configuration/v1/algolia/subscription-list/properties',
  termsAndConditions: 'configuration/v1/algolia/subscription-list/terms-and-conditions',
};
